import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { motion } from 'framer-motion';
import Container from '../ui/Container';
import useReducedMotion from '../../hooks/useReducedMotion';

/** Compact dark hero used at the top of every inner page. */
export default function PageHero({ eyebrow, title, description, breadcrumb, children }) {
  const reducedMotion = useReducedMotion();
  const animate = reducedMotion
    ? {}
    : {
        initial: { opacity: 0, y: 18 },
        animate: { opacity: 1, y: 0 },
        transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1] },
      };

  return (
    <section className="relative overflow-hidden bg-ink-950 py-16 sm:py-20">
      <div className="pointer-events-none absolute inset-0 bg-grid bg-grid-cell opacity-60" aria-hidden="true" />
      <div
        className="pointer-events-none absolute -left-24 top-0 h-80 w-80 rounded-full bg-brand-600/20 blur-[110px]"
        aria-hidden="true"
      />

      <Container className="relative">
        <motion.div {...animate}>
          <nav aria-label="Breadcrumb" className="flex items-center gap-2 text-xs text-ink-500">
            <Link to="/" className="transition hover:text-brand-300">
              Home
            </Link>
            <ChevronRight className="h-3 w-3" />
            <span className="text-brand-300">{breadcrumb || title}</span>
          </nav>

          {eyebrow && <span className="eyebrow-dark mt-6">{eyebrow}</span>}

          <h1 className="mt-5 max-w-3xl text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl">
            {title}
          </h1>

          {description && (
            <p className="mt-5 max-w-2xl text-base leading-relaxed text-ink-300 sm:text-lg">
              {description}
            </p>
          )}

          {children}
        </motion.div>
      </Container>
    </section>
  );
}
